import React from 'react';
import styles from './LoadingScreen.module.scss';

const LoadingScreen = () => {
  return (
    <div className={styles.loadingScreen}>
      <div className={styles.loadingContent}>
        <div className={styles.logo}>
          <span className={styles.logoIcon}>F</span>
        </div>
        <h2>Agent Studio</h2>
        <div className={styles.spinner}>
          <div className={styles.spinnerDot}></div>
          <div className={styles.spinnerDot}></div>
          <div className={styles.spinnerDot}></div>
        </div>
        <p>Establishing secure connection with main application...</p>
        <div className={styles.authSteps}>
          <div className={styles.step}>🔍 Checking authentication data</div>
          <div className={styles.step}>🔐 Validating security tokens</div>
          <div className={styles.step}>👤 Loading user profile</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
